import classNames from "classnames";
import { useIntl } from "react-intl";
import { NLU_HOST, WEB_HOST } from "@/core/variables";
import { Popover, PopoverButton, PopoverMenu, PopoverItem } from "@/component/Popover";
import { AppMenuIcon, CircleIcon } from "@/assets/svgs/icons";


const APP_MENU_CLASSNAME = 
    "selection-table-popover-item w-full p-2.5 rounded-[6px]"
    + " text-black-400 hover:text-chat42 hover:bg-chat42-5 data-[focus]:text-chat42 data-[focus]:bg-chat42-5";

const AppMenu: React.FC<{ className?: string }> = ({ className: propsClassName }) => {
    const intl = useIntl();
    return (
        <Popover>
            <PopoverButton aria-label={intl.formatMessage({ id: "i04088" })}
                           className={classNames("size-8 rounded-[6px]", propsClassName)}
            >
                <AppMenuIcon />
            </PopoverButton>
            <PopoverMenu anchor="bottom start"
                         className="!w-[210px] mt-2 -ml-3 px-3 py-3"
            >
                <PopoverItem className={APP_MENU_CLASSNAME}
                             onClick={() => { window.open(NLU_HOST); }}
                >
                    <CircleIcon className="size-2.5" />
                    NLU
                </PopoverItem>
                <PopoverItem className={APP_MENU_CLASSNAME}
                             onClick={() => { window.open(WEB_HOST); }}
                >
                    <CircleIcon className="size-2.5" />
                    CM
                </PopoverItem>
            </PopoverMenu>
        </Popover>
    );
};

export default AppMenu;
